/**
 * Validation utilities for game modes and other game inputs
 */

import { WordLength } from '../types/game'
import { GAME_MODES } from '../constants/gameConfig'

/**
 * Check if a value is a valid game mode
 *
 * @param value - The value to check
 * @returns True if the value is a valid game mode
 */
export const isValidMode = (value: string): boolean => {
  if (!value) {
    return false
  }

  // Ensure the value is a string consisting only of digits '3', '4', '5', or '6'
  if (!/^[3456]$/.test(value)) {
    return false
  }

  const numericValue = Number(value)

  // Check if it's a valid number and exists in the GAME_MODES object
  return (
    !isNaN(numericValue) &&
    [6, 5, 4, 3].includes(numericValue) &&
    GAME_MODES[numericValue as WordLength] !== undefined
  )
}
